//vendor
import $ from 'jquery';
import Player from '@vimeo/player';
import Helper from '../helpers/util';

class VimeoPlaylist {
	// collect all the items into an array
	constructor(el) {
		this.el = el;
		this.$el = $(el);

		this.videos = Array.from(
			this.el.querySelectorAll('.elearning-videos__list__item')
		);
		this.playerEl = this.el.querySelector('.elearning-videos__video');
		this.$image = this.$el.find('.elearning-video-thumb');
		this.$thumbnailProgress = this.$el.find(
			'.elearning-videos__list__item__thumbnail__progress'
		);
		this.$playingProgress = this.$el.find(
			'.elearning-videos__list__item__thumbnail__playing'
		);
		this.$watched = this.$el.find(
			'.elearning-videos__list__item__thumbnail__watched'
		);
		this.$videoPlayerWrapper = this.$el.find(
			'.elearning-videos__video-wrapper'
		);
		this.$videoAndDescriptionWrapper = this.$el.find(
			'.elearning-videos__video-and-description'
		);
		this.$listWrapper = this.$el.find('.elearning-videos__list');
		this.$shareButton = this.$el.find(
			'.elearning-videos__video-wrapper__share-button'
		);

		this.$likeButton = this.$el.find(
			'.elearning-videos__video-wrapper__like-button'
		);

		const urlParams = new URLSearchParams(window.location.search);
		this.myVideoId = urlParams.get('videoid');
		this.activeIndex = 0;
		this.totalVideos = this.videos.length;

		this.videos.forEach((video, index) => {
			if (video.dataset.videoId === this.myVideoId) {
				this.activeIndex = index;
			}
		});
		this.loadVideoFromId(
			this.videos[this.activeIndex].getAttribute('data-video-id')
		);

		this.attachEvents();
		this.init(this.myVideoId);
		this.adaptPlaylistHeight();
	}
	init(id) {
		if (id) {
			this.loadFromQuery(id);
			return;
		}
		this.checkIfVideoIsLiked();
		const firstId = this.videos[0].getAttribute('data-video-id');
		const firstTitle = this.videos[0].getAttribute('data-video-title');
		const firstDescription = this.videos[0].getAttribute(
			'data-video-content'
		);
		const firstTime = this.videos[0].getAttribute('data-video-length');
		const newTimestamp = `<span class="icon icon-clock"></span> ${firstTime}`;
		this.createVideoPlayer(firstId);

		$('.elearning-videos__video-description__title').text(firstTitle);
		$('.elearning-videos__video-description__content').html(
			firstDescription
		);
		$('.elearning-videos__video-wrapper__timestamp').html(newTimestamp);
	}

	attachEvents() {
		this.$videoPlayerWrapper[0].addEventListener('mouseenter', () => {
			this.$shareButton[0].classList.add('show');
			this.$likeButton[0].classList.add('show');
			this.updateShareButtonContent();
		});
		this.$videoPlayerWrapper[0].addEventListener('mouseleave', () => {
			this.$shareButton[0].classList.remove('show');
			this.$likeButton[0].classList.remove('show');
		});
		this.$likeButton[0].addEventListener('click', () => {
			this.markVideoAsLikedOnServer();
		});
		this.videos.forEach((item, index) => {
			item.addEventListener('click', () => {
				this.activeIndex = index;
				const id = item.getAttribute('data-video-id');
				const newTitle = item.getAttribute('data-video-title');
				const newDescription = item.getAttribute('data-video-content');
				const newTime = this.videos[this.activeIndex].getAttribute(
					'data-video-length'
				);
				const newTimestamp = `<span class="icon icon-clock"></span> ${newTime}`;

				$('.elearning-videos__video-description__title').text(newTitle);
				$('.elearning-videos__video-description__content').html(
					newDescription
				);
				$('.elearning-videos__video-wrapper__timestamp').html(
					newTimestamp
				);

				this.player.loadVideo(id);
				this.loadVideoFromId(id);
				this.clearOtherClasses(index);
				this.adaptPlaylistHeight();
				this.setUrlParam(id);
			});
		});
		window.addEventListener('resize', this.adaptPlaylistHeight.bind(this));
	}

	loadFromQuery = id => {
		this.checkIfVideoIsLiked();
		const videoTitle = this.videos[this.activeIndex].getAttribute(
			'data-video-title'
		);
		const videoDescription = this.videos[this.activeIndex].getAttribute(
			'data-video-content'
		);
		const videoTime = this.videos[this.activeIndex].getAttribute(
			'data-video-length'
		);
		const newTimestamp = `<span class="icon icon-clock"></span> ${videoTime}`;
		this.createVideoPlayer(id);

		$('.elearning-videos__video-description__title').text(videoTitle);
		$('.elearning-videos__video-description__content').html(
			videoDescription
		);
		$('.elearning-videos__video-wrapper__timestamp').html(newTimestamp);
	};

	createVideoPlayer = id => {
		this.player = new Player(this.playerEl, {
			id: id,
			width: 640
		});

		this.player.on('ended', this.loadNextVideo);
		this.player.on('timeupdate', props => {
			this.updateVideoStatus(props.percent);
		});
	};

	updateVideoStatus = props => {
		this.$thumbnailProgress[this.activeIndex].setAttribute(
			'class',
			'elearning-videos__list__item__thumbnail__progress--active'
		);
		this.$playingProgress[this.activeIndex].setAttribute(
			'class',
			'elearning-videos__list__item__thumbnail__playing--active'
		);
		this.$playingProgress[this.activeIndex].parentElement.classList.add(
			'has-overlay'
		);
		this.$thumbnailProgress.attr('style', `width: ${props * 100}%`);
	};

	clearClasses = () => {
		this.checkIfVideoIsLiked();
		this.$watched[this.activeIndex].setAttribute(
			'class',
			'elearning-videos__list__item__thumbnail__watched--active'
		);
		this.$thumbnailProgress[this.activeIndex].removeAttribute(
			'class',
			'elearning-videos__list__item__thumbnail__progress--active'
		);
		this.$thumbnailProgress[this.activeIndex].setAttribute(
			'class',
			'elearning-videos__list__item__thumbnail__progress'
		);
		this.$playingProgress[this.activeIndex].removeAttribute(
			'class',
			'elearning-videos__list__item__thumbnail__playing--active'
		);
		this.$playingProgress[this.activeIndex].parentElement.classList.remove(
			'has-overlay'
		);
		this.$playingProgress[this.activeIndex].setAttribute(
			'class',
			'elearning-videos__list__item__thumbnail__playing'
		);
	};
	loadNextVideo = () => {
		this.clearClasses();
		++this.activeIndex;
		const newId = this.videos[this.activeIndex].getAttribute(
			'data-video-id'
		);
		const newTitle = this.videos[this.activeIndex].getAttribute(
			'data-video-title'
		);
		const newDescription = this.videos[this.activeIndex].getAttribute(
			'data-video-content'
		);
		const newTime = this.videos[this.activeIndex].getAttribute(
			'data-video-length'
		);
		const newTimestamp = `<span class="icon icon-clock"></span> ${newTime}`;

		$('.elearning-videos__video-description__content').html(newDescription);
		$('.elearning-videos__video-description__title').text(newTitle);
		$('.elearning-videos__video-wrapper__timestamp').html(newTimestamp);
		this.player.loadVideo(newId).then(() => {
			this.player.play();
			this.setUrlParam(newId);
		});
	};

	adaptPlaylistHeight = () => {
		const browserWidth = Math.max(
			document.body.scrollWidth,
			document.documentElement.scrollWidth,
			document.body.offsetWidth,
			document.documentElement.offsetWidth,
			document.documentElement.clientWidth
		);
		let heightOfVideoDescription = 'auto';

		if (browserWidth > 1200) {
			heightOfVideoDescription =
				this.$videoAndDescriptionWrapper.height() + 'px';
		}
		this.$listWrapper.attr('style', `height: ${heightOfVideoDescription}`);

		this.$listWrapper.toggleClass(
			'has-scroll',
			this.$listWrapper[0].scrollHeight -
				this.$listWrapper[0].offsetHeight >=
				10 && browserWidth > 1200
		);
	};

	setUrlParam = id => {
		const regexp = /(\d)+/gi;
		const matches = id.match(regexp);
		window.history.replaceState(null, null, '?videoid=' + matches[0]);
	};

	updateShareButtonContent = () => {
		const subject = encodeURI(
			this.videos[this.activeIndex].getAttribute('data-video-subject')
		);
		const body = encodeURI(
			this.videos[this.activeIndex].getAttribute('data-video-body')
		);
		this.$shareButton[0].href = `mailto:?subject=${subject}&body=${body}`;
	};

	clearOtherClasses = () => {
		this.checkIfVideoIsLiked();
		for (var i = 0; i < this.videos.length; i++) {
			if (
				// the video has been watched and there is playing video bar clear it.
				this.videos[i].childNodes[1].childNodes[5].className ===
					'elearning-videos__list__item__thumbnail__watched--active' &&
				this.videos[i].childNodes[1].childNodes[3].className ===
					'elearning-videos__list__item__thumbnail__playing--active'
			) {
				this.videos[i].childNodes[1].childNodes[3].removeAttribute(
					'class',
					'elearning-videos__list__item__thumbnail__playing--active'
				);
				this.videos[
					i
				].childNodes[1].childNodes[3].parentElement.classList.remove(
					'has-overlay'
				);
				this.videos[i].childNodes[1].childNodes[3].setAttribute(
					'class',
					'elearning-videos__list__item__thumbnail__playing'
				);
				this.videos[i].childNodes[1].childNodes[7].removeAttribute(
					'class',
					'elearning-videos__list__item__thumbnail__progress--active'
				);
				this.videos[i].childNodes[1].childNodes[7].setAttribute(
					'class',
					'elearning-videos__list__item__thumbnail__progress'
				);
			} else if (
				// has the video been watched?
				this.videos[i].childNodes[1].childNodes[5].className ===
				'elearning-videos__list__item__thumbnail__watched--active'
			) {
				console.log('i am active');
			} else {
				// if the video has not been watched turn off all other playing progress bars
				if (
					this.videos[i].childNodes[1].childNodes[3].className ===
					'elearning-videos__list__item__thumbnail__playing--active'
				) {
					this.videos[i].childNodes[1].childNodes[3].removeAttribute(
						'class',
						'elearning-videos__list__item__thumbnail__playing--active'
					);
					this.videos[
						i
					].childNodes[1].childNodes[3].parentElement.classList.remove(
						'has-overlay'
					);
					this.videos[i].childNodes[1].childNodes[3].setAttribute(
						'class',
						'elearning-videos__list__item__thumbnail__playing'
					);
					this.videos[i].childNodes[1].childNodes[7].removeAttribute(
						'class',
						'elearning-videos__list__item__thumbnail__progress--active'
					);
					this.videos[i].childNodes[1].childNodes[7].setAttribute(
						'class',
						'elearning-videos__list__item__thumbnail__progress'
					);
				}
			}
		}
	};

	loadVideoFromId = id => {
		const regexp = /(\d)+/gi;
		const matches = id.match(regexp);
		$.ajax({
			type: 'GET',
			url: 'https://vimeo.com/api/v2/video/' + matches[0] + '.json',
			jsonp: 'callback',
			dataType: 'jsonp',
			success: data => {
				const videoItem = data[0];
				this.$image.attr(
					'style',
					`background-image: url('${videoItem.thumbnail_large}')`
				);
			}
		});
	};

	async checkIfVideoIsLiked() {
		const videoId = this.videos[this.activeIndex].getAttribute(
			'data-video-id'
		);
		var response = await fetch(
			`${
				location.hostname === 'localhost'
					? `https://vaxiplace2016.schweb.net.au/api/video/status/${videoId}`
					: `/api/video/status/${videoId}`
			}`
		).then(response => response.json());
		if (response) {
			this.toggleHeartActive();
		} else {
			this.toggleHeartInactive();
		}
	}

	async markVideoAsLikedOnServer() {
		this.toggleHeartActive();
		const videoId = this.videos[this.activeIndex].getAttribute(
			'data-video-id'
		);
		console.log(location.hostname);
		fetch(
			`${
				location.hostname === 'localhost'
					? 'https://vaxiplace2016.schweb.net.au/session/token'
					: '/session/token'
			}`
		)
			.then(res => res.text())
			.then(data => {
				this.token = data;

				$.ajax({
					url: `${
						location.hostname === 'localhost'
							? 'https://vaxiplace2016.schweb.net.au/api/video/save'
							: '/api/video/save'
					}`,
					data: JSON.stringify(videoId),
					type: 'POST',
					headers: {
						'X-CSRF-Token': this.token
					},
					dataType: 'json',
					contentType: 'application/json',
					success: data => {
						console.log(data);
						console.log('hello passed');
					},
					error: () => {
						console.log('hello failed');
					}
				});
			});
	}

	toggleHeartActive = () => {
		const heart = document.getElementById('heart-kol-page');
		heart.children[0].setAttribute('fill', '#d23b32');
		this.$likeButton[0].style.pointerEvents = 'none';
	};

	toggleHeartInactive = () => {
		const heart = document.getElementById('heart-kol-page');
		heart.children[0].setAttribute('fill', '#449CDF');
		this.$likeButton[0].style.pointerEvents = 'auto';
	};
}

const _init = () => {
	let $el = $('.vimeo-playlist');
	if ($el.length) {
		$el.each((i, v) => {
			if (!$(v).data('init')) {
				new VimeoPlaylist(v);
			}
		});
	}
};

_init();
Helper.pubsub.subscribe('initComponents', function() {
	_init();
});
